import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronDown, faChevronUp, faSearch, faEllipsisH, faTimes } from '@fortawesome/free-solid-svg-icons';
import pidiliteimg from './images/pidiliteimg.png';
import ArrowLeft from './images/ArrowLeft.png';
import BucketEmptyConfirmPopup from './Component/BucketEmptyConfirmPopup';
import ViewBucket from './Component/ViewBucket';
import { FiArrowLeft } from 'react-icons/fi';
//import ProductInformationSkeleton from './SkeletonLoader/ProductInformationSkeleton';

const ProductInformation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [specOpen, setSpecOpen] = useState(true);
  const [showProductDetails, setShowProductDetails] = useState(true);
  const [quantities, setQuantities] = useState({});
  const [mainProductQuantity, setMainProductQuantity] = useState(0);
  const [bucketImages, setBucketImages] = useState({});
const [userData, setUserData] = useState(null);
const [showEmptyBucketPopup, setShowEmptyBucketPopup] = useState(false);
const [pendingRemoveProductId, setPendingRemoveProductId] = useState(null);
const [pendingAction, setPendingAction] = useState(null); 
const [bucketProducts, setBucketProducts] = useState({});
const [inputValues, setInputValues] = useState({}); // Local state for input values per product
  const bucketRef = useRef(null);
  const imgRefs = useRef({});
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 const [vendorData, setVendorData] = useState(null);
  const { product, vendor_id, relatedProducts = [] } = location.state || {};
  console.log('vendor_id:', vendor_id);
  console.log('Product Information:', product);
  const [loading, setLoading] = useState(true);
  const [SimilarProducts, setSimilarProducts] = useState([])
  const [SelectedProduct, setSelectedProduct] = useState()
  const [descriptionExpanded, setDescriptionExpanded] = useState(false)
  const [specExpanded, setSpecExpanded] = useState(false);

  
  const [mainImage, setMainImage] = useState(
    product?.image_url ||
      (product?.product_image
        ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${product.product_image}`
        : '')
  );

useEffect(() => {
  const initializeData = async () => {
    setLoading(true);
    try {
      await loadBucketData();
      if (product?.vendor_id) {
        await getVendorDetails(product.vendor_id);
      }
      if (product) {
        setMainImage(
          product?.image_url ||
            (product?.product_image
              ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${product.product_image}`
              : '')
        );
        
        const savedBucketProducts = localStorage.getItem('bucketProducts');
       
        if (savedBucketProducts) {
          const parsedBucketProducts = JSON.parse(savedBucketProducts);
          console.log(parsedBucketProducts);
          console.log('product', product);
          const BucketProduct = parsedBucketProducts[product._id];
          if (product?._id && BucketProduct) {
            console.log('BucketProduct', BucketProduct);
            setMainProductQuantity(BucketProduct.quantity);
          } else {
            setMainProductQuantity(0);
          }
        } else {
          setMainProductQuantity(0);
        }
      }
    } catch (error) {
      console.error("Error initializing data:", error);
      // Optionally, you can set an error state here if needed
    } finally {
      setLoading(false);
    }
  };

  initializeData();
}, [product?.vendor_id, product?._id]);


useEffect(()=>{
 if(product && product.product_category_id){
  fetchSimilarProductsByCategoryIds()
 }
},[product])


const getCompanyInitials = (companyName) => {
  if (!companyName) return 'V';
  return companyName
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase();
};

  useEffect(() => {
  const storedUserData = sessionStorage.getItem('userData');
  if (storedUserData) {
    setUserData(JSON.parse(storedUserData));
  }
}, []);


const loadBucketData = () => {
  const savedBucketProducts = localStorage.getItem('bucketProducts');

  if (savedBucketProducts) {
    const products = JSON.parse(savedBucketProducts);
    setBucketProducts(products);

    // Build quantities from product data
    const quantities = {};
    const images = {};

    Object.values(products).forEach(product => {
      if (product._id) {
        quantities[product._id] = product.quantity || 0;
        if (product.product_image) {
          images[product._id] = true; // or store actual image path if needed
        }
      }
    });

    setQuantities(quantities);
    setBucketImages(images);
  } else {
    setQuantities({});
    setBucketImages({});
  }
};


  const getVendorDetails = async (vendorid) => {
  const token = userData?.token || sessionStorage.getItem('token');
  console.log('token:', token);
  
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-vendor-and-contacts?vendor_id=${vendorid}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    
    const result = await response.json();
    
    if (result.success) {
      setVendorData(result.data);
      console.log("Vendor Details:", result.data);
      console.log("Company Name:", result.data?.Vendor?.[0]?.company_name);
      console.log("Image:", result.data?.Vendor?.[0]?.image);
    } else {
      console.error('Failed to fetch vendor:', result.message);
    }
  } catch (error) {
    console.error('Error:', error);
  }

};


const handleQuantityChange = (productId, action, subcategoryId) => {
    const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    let productData = null
    if(product._id === productId){
      productData = product
    }else{
    productData = SimilarProducts.find(p=> p._id === productId)|| {}
    }
        
    if (action === 'increase') {
      setQuantities(prev => {
        const newQty = (prev[productId] || 0) + 1;
        const newQuantities = { ...prev, [productId]: newQty };
        window.dispatchEvent(new CustomEvent('bucketUpdated'));
        if (product) {
          currentBucketProducts[productId] = { ...productData, quantity: newQty };
          localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
          setBucketProducts({ ...currentBucketProducts });
        }
        return newQuantities;
      });
      if (!bucketImages[productId]) {
        setTimeout(() => {
          const imgEl = imgRefs.current?.[productId];
          const bucketEl = bucketRef.current;
          if (imgEl && bucketEl) {
            const fromRect = imgEl.getBoundingClientRect();
            const toRect = bucketEl.getBoundingClientRect();
            const flyingImg = document.createElement('img');
            flyingImg.src = `${imageUrl}${product.product_image || ''}`;
            flyingImg.className = 'fixed z-50 w-12 h-12 object-contain bg-white rounded-full shadow-xl border-2 border-red-400 pointer-events-none';
            flyingImg.style.top = `${fromRect.top + fromRect.height / 2 - 24}px`;
            flyingImg.style.left = `${fromRect.left + fromRect.width / 2 - 24}px`;
            flyingImg.style.transition = 'all 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            flyingImg.style.zIndex = '9999';
            document.body.appendChild(flyingImg);
            setTimeout(() => {
              flyingImg.style.top = `${toRect.top + toRect.height / 2 - 12}px`;
              flyingImg.style.left = `${toRect.left + toRect.width / 2 - 12}px`;
              flyingImg.style.transform = 'scale(0.5)';
              flyingImg.style.opacity = '0.3';
            }, 100);
            setTimeout(() => {
              setBucketImages(prev => ({ ...prev, [productId]: true }));
              if (document.body.contains(flyingImg)) {
                document.body.removeChild(flyingImg);
              }
            }, 1000);
          }
        }, 100);
      }
    } else if (action === 'decrease') {
      const currentQty = quantities[productId] || 0;
      const totalItemsInBucket = Object.values(quantities).reduce((total, qty) => total + qty, 0);
      if (currentQty === 1 && totalItemsInBucket === 1) {
        setSelectedProduct(product)
        setPendingRemoveProductId(productId);
        setShowEmptyBucketPopup(true);
        return;
      } else {
        performDecrease(productId);
      }
    }
  };

  const performDecrease = (productId) => {
    let currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    setQuantities(prevQuantities => {
      const newQty = Math.max(0, (prevQuantities[productId] || 1) - 1);
      const newQuantities = { ...prevQuantities };
      if (newQty > 0) {
        newQuantities[productId] = newQty;
        if (currentBucketProducts[productId]) {
          currentBucketProducts[productId] = { ...currentBucketProducts[productId], quantity: newQty };
        }
      } else {
        delete newQuantities[productId];
        delete currentBucketProducts[productId];
      }
      localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      setBucketProducts({ ...currentBucketProducts });
      window.dispatchEvent(new CustomEvent('bucketUpdated'));
      return newQuantities;
    });
  };

  const handleMainProductQuantityInputChange = (productid, value, subcategoryId) => {
    const parsedValue = parseInt(value, 10) || 0;
    const effectiveValue = parsedValue < 1 ? 1 : parsedValue;
    const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    const productData = currentBucketProducts[productid];
    if (productData) {
      currentBucketProducts[productid] = { ...productData, quantity: effectiveValue };
      const quantitiesData = { ...quantities };
      quantitiesData[productid] = effectiveValue;
      setQuantities(quantitiesData);
      localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      setBucketProducts({ ...currentBucketProducts });
      window.dispatchEvent(new CustomEvent('bucketUpdated'));
    }
  };

 const handleConfirm = () => {
  if (pendingRemoveProductId) {
    performDecrease(pendingRemoveProductId);
  }
  setShowEmptyBucketPopup(false);
  setPendingRemoveProductId(null);
};





  const handleViewBucket = () => {
    navigate('/consumer/cartpreview', { state: {  } });
  };

const fetchSimilarProductsByCategoryIds = async () => {
  const categoryIds = [product.product_category_id];
  try {
    const response = await fetch(fetchUrl + "product/get-products-by-category-ids", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ categoryIds }),
    });

    const data = await response.json();
    console.log("Fetched products by category IDs:", data);

    if (data.success) {
      let reorderedData = data.data || [];

      // Filter out the current product to avoid including it in similar products
      reorderedData = reorderedData.filter(p => p._id !== product._id);

      // Remove any duplicates based on _id
      reorderedData = reorderedData.filter((item, index, self) => self.findIndex(i => i._id === item._id) === index);

      if (product.product_sub_category_id) {
        const targetSubcategoryProducts = reorderedData.filter(p => p.product_sub_category_id === product.product_sub_category_id);
        if (targetSubcategoryProducts && targetSubcategoryProducts.length > 0) {
          // Put the target subcategory products first, then the remaining
          reorderedData = [
            ...targetSubcategoryProducts,
            ...reorderedData.filter(p => p.product_sub_category_id !== product.product_sub_category_id)
          ];
        }
      }
      console.log(reorderedData);
      setSimilarProducts(reorderedData);
    } else {
      setSimilarProducts([]);
    }
  } catch (error) {
    console.error("❌ Error fetching products by category IDs:", error);
  }
};


  if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400 text-xs">Loading productInfo...</p>
    </div>
  );
}

  if (!product) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <p className="text-gray-500">No product information available.</p>
        <button
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 min-h-screen flex flex-col  pb-12">
      {/* Header */}
        
      {/* Main Content - Full Width Image Section */}
      <div className="w-full mb-4">
        {/* Top Controls */}
        <div className="flex justify-between items-center px-1 py-3">
          {/* Left - Down Arrow in White Circle */}
          <div className="w-10 h-10  flex items-center justify-center">
            <FiArrowLeft
               className="w-10 h-6 cursor-pointer text-gray-700 font-normal"
               onClick={() => navigate(-1)}
             />
          </div>
          
        
          
        </div>

        {/* Large Centered Image */}
        <div className="flex justify-center items-center">
          <img
            src={mainImage}
            alt={product.product_name}
            className="w-56 h-56 object-contain"
          />
        </div>

        {/* Dots Indicator */}
    
      </div>

      {/* Product Details Section - White Background */}
     <div className="bg-white mx-4 py-1 rounded-lg mb-3">
  {/* Product Name */}
  <h2 className="text-md font-medium text-[#000000] px-4 mt-2">{product.product_name}</h2>
  {/* Price and Add Button Row */}
  <div className="flex flex-col space-y-2 justify-between  px-4 mb-3">
     <div className="text-sm font-medium space-x-2">
      <span className="text-gray-500 text-xs ">Net Qty : </span>
      <span className="text-gray-500 text-xs">1 {product?.UOM || 'Nos'}</span>
      
    </div>

    <div className="text-sm font-medium space-x-2">
      <span className="text-[#000000]">₹{product.selling_price?.toLocaleString()}</span>
      <span className="text-gray-400 text-xs ">MRP </span>
    </div>

        </div>

        {/* Separator Line */}
        <div className="border-b border-gray-200 mb-2 mx-4"></div>

       
        {/* Explore Vendor Products */}
<div 
  className="bg-white px-4 py-1 mx-4 rounded-lg mb-2 cursor-pointer hover:bg-blue-50 transition-colors border border-blue-100 shadow-sm hover:shadow-md"
  onClick={() => navigate('/consumer/vendoritems', {
    state: {
      vendorId: product?.vendor_id,
      vendorName: vendorData?.Vendor?.[0]?.company_name,
    }
  })}
>
  <div className="flex items-center">
    <div className="w-12 h-12 mr-2 p-1 flex items-center justify-center">
      {vendorData?.Vendor?.[0]?.image ? (
        <img
          src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${vendorData.Vendor[0].image}`}
          alt={vendorData?.Vendor?.[0]?.company_name}
          className="w-full h-full object-contain rounded-full"
        />
      ) : (
        <div className="w-full h-full bg-blue-200 rounded-full flex items-center justify-center">
          <span className="text-blue-800 font-bold text-sm">
            {getCompanyInitials(vendorData?.Vendor?.[0]?.company_name)}
          </span>
        </div>
      )}
    </div>

    <div className="flex flex-col">
      <span className="text-gray-900 text-sm font-semibold">
        {vendorData?.Vendor?.[0]?.company_name}
      </span>
      <span className="text-blue-600 text-xs font-medium">Explore all products</span>
    </div>
    {/* Add arrow icon */}
    <div className="ml-auto">
      <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </div>
  </div>
</div>


      </div>

   {/* View Product Details */}
<div className="px-4">
  {/* Product Details Content */}
  {showProductDetails && (
    <div className="mt-1 space-y-4 pb-1">
      {/* Product Description */}
      {product?.product_description && (
        <div className="bg-white rounded-lg border border-gray-100 p-4">
          <h4 className="text-md font-bold text-gray-700 mb-3 flex items-center">
            Product Description
          </h4>
          <p className="text-gray-700 text-[13px] leading-relaxed">
            {descriptionExpanded
              ? product.product_description
              : product.product_description.length > 150
              ? `${product.product_description.substring(0, 150)}...`
              : product.product_description}
          </p>
          {product.product_description.length > 150 && (
            <button
              onClick={() => setDescriptionExpanded(!descriptionExpanded)}
              className="text-xs text-blue-600 font-medium mt-2 hover:underline"
            >
              {descriptionExpanded ? "View Less" : "View More"}
            </button>
          )}
        </div>
      )}

      {/* Specifications */}
      {(() => {
        let specs = product.specifications;

        // Parse if it's a string
        if (typeof specs === "string") {
          try {
            specs = JSON.parse(specs);
          } catch {
            specs = [];
          }
        }

        // Filter empty entries
        specs = specs.filter((spec) => {
          const keys = Object.keys(spec);
          return !(keys.length === 1 && keys[0] === "" && spec[""] === "");
        });

        if (!Array.isArray(specs) || specs.length === 0) return null;

        const displayedSpecs = specExpanded ? specs : specs.slice(0, 3);

        return (
          <div className="bg-white rounded-lg border border-gray-100">
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <h4 className="text-md font-bold text-gray-700 flex items-center">
                Product Specifications
              </h4>
            </div>

            <div className="p-4">
              <div className="space-y-3">
                {displayedSpecs.map((spec, idx) => {
                  const key = Object.keys(spec)[0];
                  const value = spec[key];
                  return (
                    <div
                      key={idx}
                      className="flex justify-between items-center py-3 px-2 bg-gray-50 rounded-md border border-gray-100 hover:bg-gray-100 transition-colors duration-200"
                    >
                      <span className="text-sm font-semibold text-gray-700 w-2/5 pr-2 capitalize">
                        {key}
                      </span>
                      <span className="text-sm text-gray-900 w-3/5 text-right font-medium leading-relaxed">
                        {value}
                      </span>
                    </div>
                  );
                })}
              </div>

              {/* View More / View Less Button */}
              {specs.length > 3 && (
                <div className="text-start mt-3">
                  <button
                    onClick={() => setSpecExpanded(!specExpanded)}
                    className="text-xs text-blue-600 font-medium hover:underline"
                  >
                    {specExpanded ? "View Less" : "View More"}
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })()}
    </div>
  )}
</div>



 {/* Similar Products */}
{SimilarProducts && SimilarProducts.length > 1 && (
  <div className="mb-4 mt-3 p-3 bg-white">
    <h2 className="text-lg font-bold text-gray-800 mb-3">Similar Products</h2>
    <div className="flex gap-4 overflow-x-auto pb-4 no-scrollbar snap-x snap-proximity">
      {SimilarProducts
        .filter(item => item._id !== product._id)
        .map((itemData, idx) => {
          const quantity = quantities[itemData._id] || 0;
          return (
            <div
              key={itemData._id || idx}
              className="flex-shrink-0 w-32 bg-white rounded-xl shadow-xs border border-gray-50 overflow-hidden snap-start flex flex-col"
            >
              {/* Product Image */}
              <div className="relative h-28 flex items-center justify-center bg-gray-50 p-1 rounded-t-xl">
                {itemData.product_image ? (
                  <img
                    ref={(el) => (imgRefs.current[itemData._id] = el)}
                    src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${itemData.product_image}`}
                    alt={itemData.product_name}
                    className="h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200 m-2"
                    onClick={() =>
                      navigate('/consumer/productInformation', {
                        state: { product: itemData, relatedProducts, vendor_id },
                        replace: true
                      })
                    }
                  />
                ) : (
                  <div
                    className="h-full w-full flex items-center justify-center text-center font-bold text-gray-900 text-xs cursor-pointer px-1"
                    onClick={() =>
                      navigate('/consumer/productInformation', {
                        state: { product: itemData, relatedProducts, vendor_id },
                        replace: true
                      })
                    }
                  >
                    {itemData.product_name}
                  </div>
                )}

                {/* Conditional Rendering: ADD Button or Quantity Controls */}
                {quantity === 0 ? (
                  <button
                    className="absolute bottom-1 right-1 text-xs text-[#F43042] bg-white border border-[#F43042] rounded-md py-1 px-3 font-bold hover:bg-[#F43042] hover:text-white transition"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleQuantityChange( itemData._id, 'increase');
                    }}
                  >
                    ADD
                  </button>
                ) : (
                  <div className="absolute bottom-1 right-1 flex items-center bg-[#F43042] rounded-md px-1 py-0.5 shadow-sm">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleQuantityChange( itemData._id, 'decrease');
                      }}
                      className="w-4 h-4 flex items-center justify-center text-white text-md font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      −
                    </button>
                    <input
                      type="number"
                      value={inputValues[itemData._id] !== undefined ? inputValues[itemData._id] : (bucketProducts[itemData._id]?.quantity?.toString() || '1')}
                      onChange={(e) => {
                        let value = e.target.value;
                        // Limit to 3 digits and ensure it's a number
                        if (value.length > 3) value = value.slice(0, 3);
                        const numericValue = value.replace(/[^0-9]/g, ''); // Allow only digits
                        setInputValues(prev => ({ ...prev, [itemData._id]: numericValue }));
                      }}
                      onFocus={(e) => {
                        e.target.select();
                        // Initialize local value on focus
                        setInputValues(prev => ({ ...prev, [itemData._id]: (bucketProducts[itemData._id]?.quantity || 1).toString() }));
                      }}
                      onBlur={() => {
                        const value = inputValues[itemData._id] || '';
                        const parsedValue = parseInt(value, 10);
                        const effectiveValue = (!parsedValue || parsedValue < 1) ? 1 : parsedValue;
                        // Sync to global state only on blur
                        handleMainProductQuantityInputChange(itemData._id, effectiveValue.toString());
                        // Clear local value after sync
                        setInputValues(prev => {
                          const newValues = { ...prev };
                          delete newValues[itemData._id];
                          return newValues;
                        });
                      }}
                      min="1"
                      max="999"
                      className="px-auto mx-auto font-bold w-8 text-center text-sm text-white border-0 bg-transparent focus:outline-none focus:ring-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleQuantityChange( itemData._id, 'increase');
                      }}
                      className="w-4 h-4 flex items-center justify-center text-white text-md font-bold"
                    >
                      +
                    </button>
                  </div>
                )}
              </div>

              {/* Product Info (Name + Price) */}
              <div className="p-2 flex flex-col justify-between">
                <h3 className="text-xs text-[#000000] font-medium line-clamp-3 leading-snug">
                  {itemData.product_name}
                </h3>
                <p className="text-sm font-bold text-black mt-1">
                  ₹{itemData.selling_price?.toLocaleString() || 'Price not available'}
                </p>
              </div>
            </div>
          );
        })}
    </div>
  </div>
)}


<div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
  <div className="px-6 py-2 flex  justify-between items-center">
    <div className="flex flex-col">
     {/*  <span className="text-sm text-gray-500 font-medium tracking-wide"></span> */}
      <span className="text-lg md:text-lg font-bold text-gray-900 mt-1">
      ₹{product.selling_price?.toLocaleString()}
      </span>
     
        <span className="text-xs text-gray-500  mt-0.5">
         Tax Excluded
        </span>
 
    </div>

    {/* Quantity Controls */}
    {quantities[product._id] === 0 || !quantities[product._id] ? (
      <button
        onClick={() => handleQuantityChange(product._id, 'increase')}
        className="px-3 py-2 bg-red-500 text-white rounded-md font-semibold shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F43042]/50"
      >
        Add to Bucket
      </button>
    ) : (
      <div className="flex items-center justify-between bg-red-500 border border-red-500 rounded-md px-2 py-2 shadow-sm">
        <button
          onClick={() => handleQuantityChange(product._id, 'decrease')}
          className="w-5 h-5 flex items-center justify-center text-white text-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
        >
          −
        </button>
        <input
          type="number"
          value={quantities[product._id]}
          onChange={(e) => handleMainProductQuantityInputChange(product._id, e.target.value)}
          onFocus={(e) => e.target.select()}
          min="1"
          className="w-10 text-center text-md text-white font-bold border-0 bg-red-500 focus:outline-none focus:ring-0 focus:border-transparent mx-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          placeholder="1"
        />
        <button
          onClick={() => handleQuantityChange(product._id, 'increase')}
          className="w-5 h-5 flex items-center justify-center text-white text-lg font-bold"
        >
          +
        </button>
      </div>
    )}
  </div>
</div>




<ViewBucket
  bucketProducts={bucketProducts}
  imageUrl={imageUrl}
  bucketRef={bucketRef}
  onViewBucket={handleViewBucket}
  isFooterAvailable = {true}
            />

<BucketEmptyConfirmPopup
  isOpen={showEmptyBucketPopup}
  onClose={() => {
    setShowEmptyBucketPopup(false);
    setPendingRemoveProductId(null);
    setPendingAction(null);
  }}
  onConfirm={handleConfirm}
  productName={
    pendingRemoveProductId 
      ? (pendingAction === 'main' 
          ? product?.product_name 
          : relatedProducts.find(p => p._id === pendingRemoveProductId)?.product_name
        ) || "this item"
      : "this item"
  }
/>


    </div>
  );
};

export default ProductInformation;



